export default {
  0: 'n/a',
  1: 'table',
  2: 'boxplot',
  3: 'scatter',
  4: 'variwide',
  5: 'column',
  6: 'bar',
  7: 'line',
  8: 'columnWithHighlights', // Single series, with multiple groups, turns off Legend events, to hide the fact we are gaslighting it
  9: 'stackedColumn',
}